import { apiRequest } from '../../../api/client';

export const CANONICAL_PRODUCT_TOUR_CONTRACT_ID = 'route42-core-v1';

export type ProductTourStatus = 'NOT_STARTED' | 'IN_PROGRESS' | 'SKIPPED' | 'COMPLETED';
export type ProductTourAction = 'START' | 'STEP_COMPLETED' | 'SKIP' | 'COMPLETE' | 'REPLAY';

export interface ProductTourState {
  schema_version: '1.0';
  contract_id: string;
  tour_id: string;
  tour_version: number;
  status: ProductTourStatus;
  current_step_id: string | null;
  highest_step_order: number;
  completed_step_ids: string[];
  started_at: string | null;
  last_interaction_at: string | null;
  skipped_at: string | null;
  completed_at: string | null;
  replay_count: number;
  last_replay_started_at: string | null;
  updated_at: string | null;
  revision: number;
  has_completed: boolean;
  has_skipped: boolean;
}

export function getProductTourState(contractId = CANONICAL_PRODUCT_TOUR_CONTRACT_ID) {
  return apiRequest<ProductTourState>(`/v1/product-guidance/tours/${encodeURIComponent(contractId)}/state`);
}

export function transitionProductTourState(
  action: ProductTourAction,
  stepId?: string,
  contractId = CANONICAL_PRODUCT_TOUR_CONTRACT_ID,
) {
  const payload: { action: ProductTourAction; step_id?: string } = { action };
  if (stepId) payload.step_id = stepId;
  return apiRequest<ProductTourState>(`/v1/product-guidance/tours/${encodeURIComponent(contractId)}/state`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
}
